<script>
  import ListHeader from '../../../../app/components/list/Header.vue'
  import FormSaveButton from '../../../../app/components/form/SaveButton.vue'
  import FormCancelButton from '../../../../app/components/form/CancelButton.vue'
  import DataService from '../../../services/dataService'
  import * as restfulService from '../../../services/restfulService'
  import * as notifyService from '../../../services/notifyService'
  import {clone} from 'lodash'
  import {required, minLength, maxLength} from 'vuelidate/lib/validators'

  export default {
    components: {ListHeader, FormSaveButton, FormCancelButton},
    data () {
      return {
        isEdit: false,
        isSubmitted: false,
        isLoadingData: true,
        form: {
          country_id: '',
          name: '',
          initials: ''
        },
        dependencies: {}
      }
    },
    validations: {
      form: {
        country_id: {required},
        name: {required},
        initials: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(2)
        }
      }
    },
    mounted () {
      this.getDependencies()
      const id = this.$route.params.id || null
      if (id) {
        this.isEdit = true
        restfulService.get('registration', null, id)
          .then(response => {
            this.form = response
            this.isLoadingData = false
          })
          .catch(e => {
            console.log(e)
            this.isLoadingData = false
          })
      } else {
        this.isLoadingData = false
      }
    },
    methods: {
      getDependencies () {
        DataService.get([{domain: 'country'}]).then((result) => {
          this.dependencies = result
        })
      },
      onSend () {
        this.isSubmitted = true
        const data = clone(this.form)
        restfulService.save('registration', null, null, data)
          .then(() => {
            notifyService.success({hideLoader: true})
            this.isSubmitted = false
            this.$router.push({name: 'registration.index'})
          })
          .catch(e => {
            this.isSubmitted = false
            console.log(e)
          })
      }
    }
  }
</script>

<template>
    <div v-if="!isLoadingData">

        <ListHeader title="Estados"/>

        <el-card class="el-card__save_form box-card">
            <div slot="header">
                <span>Dados dos Estados</span>
            </div>
            <el-form ref="form"
                     :model="form"
                     label-width="20%"
                     v-on:submit.prevent="onSend">
                <el-form-item label="País"
                              class="is-required"
                              v-bind:class="{ 'el-form-item--error': $v.form.country_id.$error }">
                    <el-select v-model="form.country_id"
                               filterable
                               placeholder="Selecione um país"
                               empty-text="Nenhum registro encontrado"
                               class="el-select-full"
                               @input="$v.form.country_id.$touch()">
                        <el-option
                                v-for="item in dependencies.countries"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                    <div class="el-form-item__error" v-if="$v.form.country_id.$error">
                        Esse campo é obrigatório
                    </div>
                </el-form-item>
                <el-form-item label="Nome"
                              class="is-required"
                              v-bind:class="{ 'el-form-item--error': $v.form.name.$error }">
                    <el-input v-model="form.name"
                              @input="$v.form.name.$touch()"></el-input>
                    <div class="el-form-item__error" v-if="$v.form.name.$error">Esse campo é obrigatório</div>
                </el-form-item>
                <el-form-item label="UF"
                              class="is-required"
                              v-bind:class="{ 'el-form-item--error': $v.form.initials.$error }">
                    <el-input v-model="form.initials"
                              @input="$v.form.initials.$touch()"></el-input>
                    <div class="el-form-item__error" v-if="$v.form.initials.$error">Esse campo é obrigatório</div>
                </el-form-item>
                <el-form-item>
                    <form-save-button :event-click="onSend"
                                      :is-disabled="isSubmitted || $v.$invalid"
                                      :is-submitted="isSubmitted">
                    </form-save-button>
                    <form-cancel-button route-name="registration.index"/>
                </el-form-item>
            </el-form>
        </el-card>
    </div>
</template>



// WEBPACK FOOTER //
// Form.vue?1f0aebf4